import dayjs from 'dayjs';
import { PaymentPeriod } from '../types';

const HISTORIC_QUARTERLY_SLICE = 4;
const HISTORIC_MONTHLY_SLICE = 12;

export function gatherHistoricPaymentsPeriods(
  paymentPeriods: PaymentPeriod[]
): PaymentPeriod[] {
  const reverseChronologicalPaymentPeriods = paymentPeriods.sort((a, b) =>
    dayjs(b.startDate).diff(dayjs(a.startDate))
  );

  const isLatestPaymentPeriodOngoing = dayjs().isBetween(
    dayjs(reverseChronologicalPaymentPeriods[0].startDate),
    dayjs(reverseChronologicalPaymentPeriods[0].endDate)
  );

  return reverseChronologicalPaymentPeriods.slice(
    isLatestPaymentPeriodOngoing ? 1 : 0
  );
}

export function restrictToLatestYearsHistoricPeriods(
  /**
   * Assumes the following:
   * - the list of payment periods only contains historic periods (no ongoing/active/current payment periods)
   * - the list of payment periods is already in reverse chronological order
   */
  paymentPeriods: PaymentPeriod[],
  taxReportingSchedule: 'monthly' | 'quarterly'
): PaymentPeriod[] {
  return paymentPeriods.slice(
    0,
    taxReportingSchedule === 'quarterly'
      ? HISTORIC_QUARTERLY_SLICE
      : HISTORIC_MONTHLY_SLICE
  );
}
